// 组件类
import {
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { RSHeaderComponent } from "../rs-header/index.component";
import { DrawerComponent } from "../drawer/index.component";
import { DrawerService } from "../../service/drawer.service";
import { MultiTabComponent } from "../multi-tab/index.component";
import { debounce } from "lodash";
import ResizeObserver from "resize-observer-polyfill";

@Component({
  selector: "rs-main-container",
  templateUrl: "./index.component.html",
  styleUrls: ["./index.component.scss"],
})
export class MainContainerComponent implements OnInit {
  @ContentChild(RSHeaderComponent, { static: true }) headerRef;
  @ContentChild(MultiTabComponent, { static: true }) multiTabRef;

  @ViewChild("drawer", { static: false }) drawer: DrawerComponent;

  @Input() isCollapsed: boolean = false; // 接收输入属性
  @Input() singleReuseUrls: string[] = []; //只能单个缓存的url
  @Output() onWidthChange = new EventEmitter();

  private resizeObserver: ResizeObserver;
  private debouncedHandleResize: (width: number) => void;
  constructor(
    private globalDrawer: DrawerService,
    private elementRef: ElementRef
  ) {
    this.debouncedHandleResize = debounce((width: number) => {
      // console.log("Debounced width change:", width);
      // 在这里处理防抖后的宽度变化逻辑
      this.multiTabRef && this.multiTabRef.setEllipsisTitle();
      this.onWidthChange.emit(width);
    }, 300);
  }

  ngOnInit() {}

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    const screenWidth = window.innerWidth; // 更新屏幕宽度
    if (screenWidth <= 992) {
      this.headerRef && this.headerRef.onToggleMenu(false);
    } else if (screenWidth < 1200) {
      this.headerRef && this.headerRef.onToggleMenu(true);
    } else {
      this.headerRef && this.headerRef.onToggleMenu(false);
    }
  }

  ngAfterViewInit() {
    this.globalDrawer.setDrawer(this.drawer); // 设置抽屉组件
    const rightAside =
      this.elementRef.nativeElement.querySelector(".right-aside");
    this.resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const width = entry.contentRect.width;
        this.debouncedHandleResize(width);
      }
    });
    this.resizeObserver.observe(rightAside);
  }

  ngOnDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  onRightAsideClick() {
    const screenWidth = window.innerWidth;
    if (screenWidth <= 992 && this.isCollapsed) {
      this.headerRef && this.headerRef.onToggleMenu();
    }
  }
}
